<template>
        <div class="modal fade" id="itemPreviewModal" tabindex="-1" role="dialog">
            <div class="modal-dialog overflow-x-hidden modal-dialog-scrollable">
                <div class="modal-content overflow-x-hidden">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h4 class="modal-title font-weight-bold" v-if="item != null" v-html="itemName"></h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body overflow-x-hidden position-relative" v-if="item != null">
                        <div class="highlight-content" v-if="item.item.free1 && item.item.free1.length > 1">
                            <span class="bg-danger text-white px-2 py-1">
                                {{ item.item.free1 }}
                            </span>
                        </div>
                        <div class="thumb-wishlist">
                            <add-to-wish-list :variation-id="item.variation.id"></add-to-wish-list>
                        </div>
                        <div class="item-images mb-5" :style="{'visibility': visibleStatus}">
                            <category-image-carousel :image-urls-data="item.images | itemImages(imageUrlAccessor)"
                                                    :key="item.item.id"
                                                    :alt="item | itemName"
                                                    :title="item | itemName"
                                                    :item-url="item | itemURL(urlWithVariationId)"
                                                    :show-dots="true"
                                                    :show-nav="true"
                                                    :enable-carousel="true"
                                                    :disable-lazy-load="true"
                                                    :disable-carousel-on-mobile="false"
                                                    ref="categoryImageCarousel">
                            </category-image-carousel>
                        </div>
                        <div class="mt-4" :class="{'pt-4': !category}">
                            <div class="mb-2" v-if="category">
                                <small class="text-primary" v-html="category"></small>
                            </div>
                            <h4 class="font-weight-bold">
                                <span v-html="itemName"></span><!--
                                --><span v-for="attribute in item.groupedAttributes">{{ "Ceres::Template.itemGroupedAttribute" | translate(attribute) }}</span>
                            </h4>
                        </div>
                        <div class="d-flex justify-content-between align-content-center mb-5">
                            <div class="w-100 d-flex align-items-center flex-wrap">
                                <div id="feedback-stars-average" class="feedback-stars-average feedback-category-view own mr-2">
                                    <div class="feedback-stars-background clearfix">
                                        <div class="feedback-star"><i class="fa fa-star"></i></div>
                                        <div class="feedback-star"><i class="fa fa-star"></i></div>
                                        <div class="feedback-star"><i class="fa fa-star"></i></div>
                                        <div class="feedback-star"><i class="fa fa-star"></i></div>
                                        <div class="feedback-star"><i class="fa fa-star"></i></div>
                                    </div>
                                    <div class="feedback-stars-overlay-wrap"
                                        v-if="item.item.feedbackDecimal > 0"
                                        :style="{width: fillStars}">
                                        <div class="feedback-stars-overlay clearfix">
                                            <div class="feedback-star"><i class="fa fa-star"></i></div>
                                            <div class="feedback-star"><i class="fa fa-star"></i></div>
                                            <div class="feedback-star"><i class="fa fa-star"></i></div>
                                            <div class="feedback-star"><i class="fa fa-star"></i></div>
                                            <div class="feedback-star"><i class="fa fa-star"></i></div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="item.item.feedbackCount > 0" class="feedback-count">
                                    <span>({{ item.item.feedbackCount }} {{ $translate("Feedback::Feedback.customerReviews") }})</span>
                                </div>
                            </div>
                            <div class="availability pl-3" :class="{'text-success': item.variation.availability.id == 1, 'text-warning': item.variation.availability.id > 1 && item.variation.availability.id < 7, 'text-danger': item.variation.availability.id > 6 }">
                                <i class="fa"
                                    :class="{
                                    'fa-check-circle': item.variation.availability.id === 1 || item.variation.availability.id === 3,
                                    'fa-times-circle': item.variation.availability.id === 7,
                                    'fa-circle': item.variation.availability.id !== 1 && item.variation.availability.id !== 3 && item.variation.availability.id !== 7
                                    }">
                                </i>
                                <span>{{ item.variation.availability.names.name }}</span>
                            </div>
                        </div>
                        <div class="text-right mb-1" v-if="item.item.free2 === '1'">
                            <div class="d-inline-block">
                                <svg xmlns="http://www.w3.org/2000/svg" width="1.25rem" height="1.25rem" preserveAspectRatio="xMidYMid meet" viewBox="0 0 640 512"><path fill="#d4021d" d="M425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5c-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9zm212.6-112.2L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64L69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9z"></path></svg>
                            </div>
                            <div class="d-inline-block text-primary font-weight-bold">GONSERBOX</div>
                        </div>
                        <div class="row align-items-center mb-5">
                            <div class="col-7 col-sm-6">
                                <ul class="fa-ul list-unstyled">
                                    <li class="buy-box-check mb-2">
                                        <i class="fa fa-check-square-o fa-li text-success" aria-hidden="true"></i><!--
                                        --><span v-html="$translate('GonserDT::Template.itemUspGuarantee')"></span>
                                    </li>
                                    <li class="buy-box-check mb-2">
                                        <i class="fa fa-check-square-o fa-li text-success" aria-hidden="true"></i><!--
                                        --><span v-html="$translate('GonserDT::Template.itemUspRefund')"></span>
                                    </li>
                                    <li class="buy-box-check" v-if="item.variation.availability.id == 1">
                                    <i class="fa fa-check-square-o fa-li text-success" aria-hidden="true"></i><!--
                                        --><span v-html="$translate('GonserDT::Template.itemUspDelivery')"></span>
                                    </li>
                                </ul>

                            </div>
                            <div class="col-5 col-sm-6 buy-box-inner-right text-right pl-0">
                                <div class="prices text-right">
                                    <div class="calculated text-primary font-weight-bold mb-1"
                                        v-if="item.prices.rrp && item.prices.rrp.unitPrice.value > 0 && item.prices.rrp.unitPrice.value > item.prices.default.unitPrice.value">
                                        <span v-if="item.prices.specialOffer">
                                            {{ $translate("GonserDT::Template.itemYouSave", {
                                                    value: ((item.prices.rrp.unitPrice.value-item.prices.specialOffer.unitPrice.value)/item.prices.rrp.unitPrice.value * 100).toFixed(2)
                                                    })
                                                }}
                                        </span>
                                        <span v-else>
                                                {{ $translate("GonserDT::Template.itemYouSave", {
                                                    value: ((item.prices.rrp.unitPrice.value-item.prices.default.unitPrice.value)/item.prices.rrp.unitPrice.value * 100).toFixed(2)
                                                    })
                                                }}
                                        </span>
                                    </div>
                                    <div v-if="item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.unitPrice.value && item.variation.availability.id < 5"
                                        class="price-view-port">
                                        <div class="crossprice mb-0" v-if="item.prices.specialOffer">
                                            <del class="text-muted">
                                                {{ $translate("GonserDT::Template.itemYouSave", {
                                                    value: ((item.prices.rrp.unitPrice.value-item.prices.default.unitPrice.value)/item.prices.rrp.unitPrice.value * 100).toFixed(2)
                                                    })
                                                }}
                                            </del>
                                        </div>
                                        <div class="crossprice" v-else>
                                            <del class="text-muted">
                                                {{ $translate("GonserDT::Template.itemUvp", {
                                                        price: $options.filters.currency(item.prices.rrp.unitPrice.value, " ")
                                                    })
                                                }}
                                            </del>
                                        </div>
                                    </div>
                                    <div class="price">
                                        <span class="custom_currency">CHF</span><!--
                                    --><span class="custom_price h1 font-weight-bolder text-primary" v-if="item.prices.specialOffer">
                                            {{ item.prices.specialOffer.unitPrice.value | currency(" ") }}
                                        </span><!--
                                        --><span class="custom_price h1 font-weight-bolder text-primary" v-else>
                                            {{ item.prices.default.unitPrice.value | currency(" ") }}
                                        </span>
                                    </div>
                                    <div class="vat small text-muted text-right">
                                        <span v-if="item.item.free2 === '1'" class="shippings-out">
                                            {{ $translate("Ceres::Template.singleItemExclusive") }}
                                        </span>
                                        <span v-else class="shippings-in">
                                            {{ $translate("Ceres::Template.singleItemIncludeAbbr") }}
                                        </span>
                                        <span>
                                            {{ $translate("Ceres::Template.singleItemShippingCosts") }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="item-description-container">
                            <div class="item-description gonser-list-style">
                                <div v-html="item.texts.description"></div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer d-block">
                        <div class="row" v-if="item != null">
                            <div v-if="item.variation.availability.id < 5" class="col-6 pl-0">
                                <a class="btn btn-default btn-block w-100" :href="item | itemURL(urlWithVariationId)">
                                    {{ $translate("GonserDT::Template.generalToItem") }}<i class="fa fa-arrow-right"></i>
                                </a>
                            </div>
                            <div class="col-6 pr-0" @click="close()">
                                <client-only>
                                    <add-to-basket
                                        :variation-id="item.variation.id"
                                        :is-salable="!!item.filter && item.filter.isSalable"
                                        :has-children="!!item.item && item.item.salableVariationCount > 1"
                                        :interval-quantity="item.variation.intervalOrderQuantity || 1"
                                        :minimum-quantity="item.variation.minimumOrderQuantity"
                                        :maximum-quantity="!!item.variation.maximumOrderQuantity && item.variation.maximumOrderQuantity > 0 ? item.variation.maximumOrderQuantity : null"
                                        :order-properties="item.properties.filter(function(prop) { return prop.property.isOderProperty })"
                                        :has-order-properties="item.hasOrderProperties"
                                        :has-required-order-property="item.hasRequiredOrderProperty"
                                        :use-large-scale="false"
                                        :show-quantity="false"
                                        :is-wish-list="true"
                                        :item-url="item | itemURL(urlWithVariationId)"
                                        :has-price="item | hasItemDefaultPrice"
                                        :with-success-icon="true"
                                        :item-type="item.item.itemType"
                                        :event-stop="false"
                                    >
                                    </add-to-basket>
                                </client-only>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import { mapState } from "vuex";
import CategoryImageCarousel from "./CategoryImageCarousel.vue";
import ItemStoreSpecial from "./ItemStoreSpecial.vue";

const ModalService  = require("../../services/ModalService");

export default {
    components: {
        CategoryImageCarousel,
        ItemStoreSpecial
    },

    props: {
        decimalCount:
            {
                type: Number,
                default: 0
            },
        imageUrlAccessor:
            {
                type: String,
                default: "url"
            },
        itemData:
            {
                type: Object
            },
        disableCarouselOnMobile:
            {
                type: Boolean
            },
        paddingClasses:
            {
                type: String,
                default: null
            },
        paddingInlineStyles:
            {
                type: String,
                default: null
            },
        forceUrlWithVariationId:
            {
                type: Boolean,
                default: false
            },
        showBasketBtn:
            {
                type: Boolean,
                default: false
            },
        withSuccessIcon:
            {
                type: Boolean,
                default: false
            },
        breadcrumbs: {
            type: Array
        }
    },

    data()
    {
        return {
            visibleStatus: 'hidden'
        }
    },

    created()
    {
        this.$nextTick(() => {
            const itemPreviewModal = ModalService
                .findModal(document.getElementById("itemPreviewModal"))
                .getModalContainer();
            itemPreviewModal.on('hide.bs.modal', () => {
                this.visibleStatus = 'hidden';
            });
            itemPreviewModal.on('show.bs.modal', () => {
                setTimeout(() => {
                    this.visibleStatus = 'visible';
                }, 750);
            });
        });
    },

    computed:
        {
            /**
             * returns itemData.item.storeSpecial
             */
            storeSpecial()
            {
                return this.item.item.storeSpecial;
            },

            /**
             * returns itemData.texts
             */
            texts()
            {
                return this.item.texts;
            },

            itemPrice()
            {
                return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, "unitPrice", "formatted" );
            },

            urlWithVariationId()
            {
                return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0 || this.forceUrlWithVariationId;
            },

            category()
            {
                if (this.breadcrumbs != null && this.breadcrumbs.length > 0 && this.breadcrumbs[this.breadcrumbs.length-1] != null)
                {
                    return this.breadcrumbs[this.breadcrumbs.length-1].details[0].name;
                }
                return null;
            },

            fillStars() {
                return (this.item.item.feedbackDecimal * 100) / 5 + '%'
            },

            itemName() {
                return this.$options.filters.itemName(
                    this.item,
                    "name1"
                );
            },

            ...mapState({
                item: state => state.itemPreview.item
            })
        },

    methods: {
        close()
        {
            ModalService
                .findModal(document.getElementById("itemPreviewModal"))
                .hide();
        }
    }
}
</script>
